import { Component } from 'react';
import PropTypes from 'prop-types';
import { registerField } from '%/utils/customForm';
import Checkbox from '../Checkbox';
import FieldGroup from '../../FieldGroup';

export default class ContactFieldGroup extends Component {
  render() {
    const { mailing, whatsapping, phoning } = this.props;

    return (
      <FieldGroup customClasses="contact-field-group">
        <legend className="contact-field-group__label">
          Quero receber contato por:
        </legend>
        <div className="contact-field-group__wrapper">
          <Checkbox
            label="E-mail"
            name="mailing"
            value={mailing}
            isChecked={false}
            {...registerField('mailing')}
          />
          <Checkbox
            label="Whatsapp"
            name="whatsapping"
            value={whatsapping}
            isChecked={false}
            {...registerField('whatsapping')}
          />
          <Checkbox
            label="Telefone"
            name="phoning"
            value={phoning}
            isChecked={false}
            {...registerField('phoning')}
          />
        </div>
      </FieldGroup>
    );
  }
}

ContactFieldGroup.propTypes = {
  onChange: PropTypes.func,
};

ContactFieldGroup.propTypes = {
  mailing: PropTypes.bool,
  whatsapping: PropTypes.bool,
  phoning: PropTypes.bool,
};
